<template>
  <div>
    <div class="footer-bar-box" :class="value ? 'footer-bar-active':'footer-bar-hide'">
      <div class="footer-bar-inner-box" :style="{'background-color':color}">
        <svg
          class="icon"
          v-for="(svg,idx) in items"
          :key="idx"
          :style="{width:(100/items.length)+'%'}"
          aria-hidden="true"
          @click="routerPush(svg[itemLink])"
        >
          <use :xlink:href="svg[itemIcon]" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
// 使用前请自行引入相关的svg图标
export default {
  props: {
    value: { default: false, type: Boolean },
    color: { default: "rgba(0,0,0,.2)", type: String },
    itemIcon: { default: "icon", type: String },
    itemLink: { default: "link", type: String },
    items: {
      default: function() {
        return [];
      },
      type: Array
    }
  },
  methods: {
    routerPush(path) {
      if (!!path && path !== this.$route.path) {
        this.$router.push({ path: path });
      }
    }
  }
};
</script>

<style>
.icon {
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.footer-bar-hide:hover {
  bottom: -15px;
  transition: bottom 0.3s;
}
.footer-bar-hide {
  bottom: -75px;
  transition: bottom 0.3s;
}

.footer-bar-active {
  bottom: -15px;
}

.footer-bar-box {
  position: fixed;
  transition: bottom 0.3s;
  width: 100%;
  display: inline-flex;
  display: -webkit-inline-flex;

  align-items: center;
  justify-content: center;
}

.footer-bar-inner-box {
  padding: 10px;
  width: 60%;
  line-height: 80px;
  border-radius: 30px 30px 0 0;
  height: 100px;
  /* left: 40%; */
  /* margin-left: -10%; */
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-bar-inner-box svg {
  width: 25%;
  height: 60px;
  transition: height 0.3s;
  /* opacity: .7; */
}

.footer-bar-inner-box svg:hover {
  height: 80px;
  cursor: pointer;
}
</style>